module.exports = __webpack_public_path__ + "fonts/iconfont.a4abf23a.ttf";